import {TranslateUtils} from '@wallaby-ui/core';
import React from 'react';
import {useIntl} from 'react-intl';

import styles from './TranslatedLabelValue.less';

interface OwnProps {
  label: string;
  value?: string;
}

type Props = OwnProps;

export const TranslatedLabelValue: React.FC<Props> = (props) => {
  const {label, value} = props;
  const intl = useIntl();

  const translatedLabel = TranslateUtils.translate(label, intl);
  const notAvailableValue = TranslateUtils.translate(
    'label.data.notAvailable',
    intl
  );

  return (
    <div className={styles.dlTranslatedLabelValueWrapper}>
      <div className={styles.dlTranslatedLabel}>{translatedLabel}</div>
      <div className={styles.dlTranslatedValue}>
        {value ?? notAvailableValue}
      </div>
    </div>
  );
};
